module.exports = [
	{
		"id": 1,
		"name": "The Lich",
		"episodes": [
			5,
			25,
			50,
			51,
			85,
			104,
			105,
			106,
			156,
			157,
			158,
			182,
			192,
			195,
			222,
			254,
			261,
			265
		]
	},
	{
		"id": 2,
		"name": "Comet Boys",
		"episodes": [
			138,
			180,
			181,
			183,
			196,
			198
		]
	},
	{
		"id": 3,
		"name": "The Ice King",
		"episodes": [
			3,
			7,
			17,
			24,
			28,
			50,
			51,
			59,
			61,
			71,
			72,
			87,
			103,
			107,
			112,
			115,
			118,
			126,
			134,
			136,
			144,
			152,
			180,
			188,
			191,
			193,
			196,
			208,
			220,
			226,
			233,
			235,
			255,
			256,
			260,
			261,
			264,
			268
		]
	},
	{
		"id": 4,
		"name": "Marceline",
		"episodes": [
			12,
			22,
			27,
			46,
			52,
			55,
			62,
			73,
			83,
			84,
			103,
			115,
			118,
			133,
			142,
			152,
			170,
			191,
			192,
			201,
			205,
			206,
			207,
			208,
			209,
			210,
			211,
			212,
			226,
			235,
			254,
			260,
			263,
			271,
			273
		]
	},
	{
		"id": 5,
		"name": "Simon & Marcy",
		"episodes": [
			55,
			71,
			72,
			103,
			118,
			133,
			152,
			194
		]
	},
	{
		"id": 6,
		"name": "Finn's Relationships",
		"episodes": [
			1,
			7,
			36,
			41,
			46,
			57,
			60,
			62,
			78,
			79,
			94,
			100,
			116,
			134,
			135,
			136,
			139,
			151,
			162,
			179,
			184,
			224,
			267
		]
	},
	{
		"id": 7,
		"name": "Flame Princess",
		"episodes": [
			78,
			79,
			94,
			96,
			100,
			116,
			131,
			134,
			136,
			139,
			151,
			170,
			178,
			184,
			231,
			233,
			259,
			260,
			261,
			269
		]
	},
	{
		"id": 8,
		"name": "The Ghost Lady",
		"episodes": [
			64,
			96,
			138
		]
	},
	{
		"id": 9,
		"name": "The Earldom of Lemongrab",
		"episodes": [
			57,
			98,
			113,
			128,
			135,
			154,
			155,
			184
		]
	},
	{
		"id": 10,
		"name": "Jake the Dad",
		"episodes": [
			9,
			38,
			97,
			110,
			120,
			127,
			128,
			131,
			140,
			168,
			186,
			189
		]
	},
	{
		"id": 11,
		"name": "Princess Bubblegum",
		"episodes": [
			1,
			41,
			57,
			65,
			88,
			97,
			98,
			125,
			130,
			136,
			138,
			142,
			146,
			148,
			150,
			153,
			159,
			160,
			166,
			178,
			179,
			191,
			198,
			200,
			201,
			205,
			207,
			209,
			210,
			211,
			212,
			255,
			266,
			233,
			235,
			242,
			244,
			245,
			254,
			260,
			270,
			271
		]
	},
	{
		"id": 12,
		"name": "King of Ooo",
		"episodes": [
			148,
			182,
			198,
			200,
			201,
			203,
			209,
			210,
			212
		]
	},
	{
		"id": 13,
		"name": "Finn's Right Arm",
		"episodes": [
			50,
			96,
			104,
			105,
			106,
			120,
			138,
			140,
			149,
			157,
			158,
			160,
			162,
			184,
			198
		]
	},
	{
		"id": 14,
		"name": "Martin the Human",
		"episodes": [
			156,
			157,
			158,
			160,
			181,
			183,
			192,
			197,
			199,
			250
		]
	},
	{
		"id": 15,
		"name": "Something Big",
		"episodes": [
			55,
			62,
			133,
			166
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/major-arcs.json
// module id = 146
// module chunks = 0